export { default } from "./HomeXraySection";
